import * as React from 'react'
import { Helmet } from 'react-helmet'
import Header from '../components/layouts/Header'
import Footer from '../components/layouts/Footer'
import SkillBridgeSection from '../components/sections/SkillBridge'

const SkillBridge = () => {
  return (
    <>
      <Helmet>
        <title>SkillBridge | POD Global</title>
        <meta
          name='description'
          content='Pod helps enterprises translate military experience into enterprise-ready SkillBridge talent.'
        />
        <meta property='og:title' content='SkillBridge | POD Global' />
        <meta
          property='og:description'
          content='Pod helps enterprises translate military experience into enterprise-ready SkillBridge talent.'
        />
      </Helmet>
      <div id='smooth-wrapper'>
        <div id='smooth-content'>
          <div className='podio'>
            <SkillBridgeSection />
            <Footer />
          </div>
        </div>
      </div>
      <Header />
    </>
  )
}

export default SkillBridge
